import { css } from '@emotion/react';
import { Divider, Grid, useMediaQuery } from '@material-ui/core';

import Button from 'components/shared/Button/Button';
import ConfirmationIcon from 'components/Waiver/Confirmation/ConfirmationIcon';
import Details from 'components/Waiver/Confirmation/Details';
import Title from 'components/Waiver/Confirmation/Title';
import ValidationText from 'components/Waiver/Confirmation/ValidationText';
import dayjs from 'dayjs';
import { i18n } from 'lib/i18n';
import { mobileOnly, tabletUp } from 'styles/utils';
import { EDateFormats } from 'types/times';
import { UserSettings } from 'types/userSettings';

const thanksBtnCss = css`
	&.MuiButtonBase-root {
		height: 48px;
		padding: 14px 16px;
		font-style: normal;
		font-weight: bold;
		line-height: 20px;
		text-align: center;
		margin-right: 10px;
		border-radius: 3px;
		min-width: 102px;
	}
`;

const layoutBtncss = css`
	margin-top: 100px;
`;

const containerCss = css`
	${mobileOnly} {
		display: flex;
	}
`;

const marginTopCss = css`
	${tabletUp} {
		margin-top: 30px;
	}
`;

export interface Props {
	confirmed: (addAnotherWaiver: boolean) => void;
	selectedMember?: UserSettings | null;
	waiverTitle?: string;
}

const WaiverConfirmation = ({ confirmed, selectedMember, waiverTitle }: Props) => {
	console.log('selectedMember', selectedMember);

	const isMobile = useMediaQuery(mobileOnly);
	const handleThanksBtnClick = () => {
		confirmed(false);
	};

	const handleSignAnotherBtnClick = () => {
		confirmed(true);
	};

	return (
		<Grid>
			<Title confirmationTitle={i18n.waiver.confirmation.title} />
			<div data-aid="WaiverConfirmation-cont" css={containerCss}>
				<ConfirmationIcon />
				<div css={marginTopCss} />
				<ValidationText
					completedText={i18n.waiver.confirmation.completed(
						waiverTitle ? (waiverTitle as string) : i18n.waiver.confirmation.fallbackFormTitle
					)}
				/>
			</div>

			<Details
				memberName={`${selectedMember?.firstName} ${selectedMember?.lastName}`}
				signedDate={dayjs().format(EDateFormats.MMM_D_YYYY)}
			/>
			<Divider />

			<Grid container css={layoutBtncss}>
				<Grid item>
					<Button
						data-aid="button-WaiverConfirmation-confirm"
						css={thanksBtnCss}
						variant="outlined"
						size="large"
						onClick={handleThanksBtnClick}
					>
						{i18n.buttons.waiverConfirmation}
					</Button>
				</Grid>
				<Grid item xs={isMobile ? 7 : 4}>
					<Button
						data-aid="button-WaiverConfirmation-sign"
						variant="contained"
						color="secondary"
						size="large"
						onClick={handleSignAnotherBtnClick}
					>
						{i18n.buttons.signAnotherWaiver}
					</Button>
				</Grid>
			</Grid>
		</Grid>
	);
};

export default WaiverConfirmation;
